import './BeginIntegrate.scss';
import Card from 'components/chrome/Card';
import React from 'react';
import Sitemap from 'components/app/Sitemap';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { NavLink } from 'react-router-dom';


class BeginIntegrate extends React.Component {

  constructor() {
    super();
    this.sitemap = new Sitemap.Factory().create();
    this.state = {
      client_api_version: '1.0.0',
      client_type: 'ios',
    };
  }

  render() {
    return (
      <div className='BeginIntegrate'>
        <div className='section'>
          <div className='subtitle'>Integrate with your API</div>
          <p>Explore tools to help you make the most of your cloud.</p>
        </div>
        <Card
            header='Client libraries'
            text='These libraries can be used directly in your devices or apps, making it easy to integrate with your API.'
            className='section'
            childrenPadded>
          <div className='clientLibraries'>
            <div className='dropdownWithLabel'>
              <div className='label'>
                API Version
              </div>
              <Dropdown
                  value={this.state.client_api_version}
                  onChange={e => this.setState({client_api_version: e.value})}
                  appendTo={document.body}
                  options={[
                    { label: '1.0.0', value: '1.0.0' },
                  ]} />
            </div>
            <div className='dropdownWithLabel'>
              <div className='label'>
                Client Type
              </div>
              <Dropdown
                  value={this.state.client_type}
                  onChange={e => this.setState({client_type: e.value})}
                  appendTo={document.body}
                  options={[
                    { label: 'iOS', value: 'ios' },
                    { label: 'Android', value: 'android' },
                    { label: 'Web', value: 'web' },
                    { label: 'C', value: 'c' },
                  ]} />
            </div>
            <div className='downloadButtonWrapper'>
              <Button
                  className='right'
                  label='Download'
                  icon='pi pi-download'
                  iconPos='right'
                  />
            </div>
          </div>
        </Card>
        <div className='section'>
          <div className='p-grid'>
            <div className='p-col-6'>
              <Card
                  header='API specification'
                  text='View the documentation for interfaces and behaviors defined in your API.'
                  buttonPrimaryLabel='View documentation' />
            </div>
            <div className='p-col-6'>
              <Card
                  header='System architecture'
                  text='Understand the system design of your cloud.'
                  buttonPrimaryLabel='View architecture' />
            </div>
            <div className='p-col-6'>
              <Card
                  header='Quality management'
                  text='Retrieve required documents for IEC 62304 and ISO 13485'
                  buttonPrimaryLabel='View documents' />
            </div>
          </div>
        </div>
        <div className='section'>
          <div className='right'>
            <NavLink to={this.sitemap.getNextUrl()}>
              <Button icon='pi pi-chevron-right' iconPos='right' label='Continue' />
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}


export default BeginIntegrate;
